// assets/js/theme/mobile-icons.js
(() => {
    let loaded = false;
  
    function injectIcons(iconMap){
      const scope = document.getElementById('mobile-menu');
      if (!scope) return;
      scope.querySelectorAll('a[data-cat-id]').forEach(link => {
        if (link.querySelector('img.nav-icon')) return;
        const id = link.getAttribute('data-cat-id');
        const path = iconMap[id] ? "https://pc.canterberrygifts.com/" + iconMap[id]
                                 : "https://pc.canterberrygifts.com/uploads/icons/default.svg";
        const img = document.createElement('img');
        img.src = path; img.alt = ''; img.className = 'nav-icon';
        link.prepend(img);
      });
    }
  
    async function loadAndInject(){
      if (loaded) return;
      loaded = true;
      try {
        const cached = sessionStorage.getItem('pc_icon_map');
        let iconMap = cached ? JSON.parse(cached) : null;
        if (!iconMap) {
          const res = await fetch('https://pc.canterberrygifts.com/api/get_categories_with_icons.php');
          const data = await res.json();
          iconMap = {};
          data.forEach(p => p.children.forEach(c => c.children.forEach(gc => {
            iconMap[gc.bc_category_id] = gc.svg_icon || "uploads/icons/default.svg";
          })));
          sessionStorage.setItem('pc_icon_map', JSON.stringify(iconMap));
        }
        injectIcons(iconMap);
      } catch (e) { console.warn('Icon map failed', e); }
    }
  
    // When the drawer opens, Cornerstone adds .is-open to #mobile-menu
    const target = document.getElementById('mobile-menu');
    if (!target) return;
    const obs = new MutationObserver(mutations => {
      if ([...mutations].some(m => m.attributeName === 'class' && target.classList.contains('is-open'))) {
        loadAndInject();
      }
    });
    obs.observe(target, { attributes: true });
  })();
  
